import { render, staticRenderFns } from "./TabbedPortletFoot.vue?vue&type=template&id=184055b4&scoped=true&"
import script from "./TabbedPortletFoot.vue?vue&type=script&lang=js&"
export * from "./TabbedPortletFoot.vue?vue&type=script&lang=js&"
import style0 from "./TabbedPortletFoot.vue?vue&type=style&index=0&id=184055b4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "184055b4",
  null
  
)

export default component.exports